import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import Grid from "@material-ui/core/Grid";
import {useNavigate} from "react-router-dom";
import {Memberships} from "./Memberships";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {MembershipDataRow} from "./MembershipDataRow";
import {makeStyles} from "@material-ui/core/styles";
import {ExportMembers} from "../../members/shared/actions/ExportMembers";
import {Button} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    actionRow: {
        display: 'flex',
        justifyContent: 'flex-end',
        '& > *': {
            marginLeft: '10px',
        },
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            '& > *': {
                marginBottom: '5px',
            }
        }
    }
}));
export const OrganizationUnitMemberships = (props: any) => {
    const {organizationId, organizationUnitId, onMembershipChanged} = props;
    const {t} = useTranslation();
    const navigate = useNavigate();
    const classes = useStyles();
    const [refresh, setRefresh] = useState(0);
    const [exportToCsv, setExportToCsv] = useState(false);

    const moveMember = () => {
        navigate(`/members/move?returnUrl=/organization-units/${organizationUnitId}/detail?tab=0`);
    };

    const assignSubscriptions = () => {
        navigate(`/organization-units/${organizationUnitId}/subscriptions-assignment`);
    };

    const headerTemplate = () =>
        <TableRow>
            <TableCell></TableCell>
            <TableCell>
                <label>
                    {t('_Common.Labels.User')}
                </label>
            </TableCell>
            <TableCell>
                <label>
                    {t('Subscription.Membership.Table.Headers.Type')}
                </label>
            </TableCell>
            <TableCell>
                <label>
                    {t('Subscription.Membership.Table.Headers.ExpirationDate')}
                </label>
            </TableCell>
            <TableCell>
                <label>
                    {t(`Subscription.Membership.Table.Headers.Actions`)}
                </label>
            </TableCell>
        </TableRow>;

    const handleModification = () => {
        setRefresh(i => i + 1);
        onMembershipChanged();
    };

    const rowTemplate = (membership: any) => <MembershipDataRow
        key={membership.id}
        values={membership}
        organizationId={organizationId}
        organizationUnitId={organizationUnitId}
        onActionCompleted={handleModification}/>;

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} className={classes.actionRow}>
                <Button variant="contained" disableElevation
                        color="primary"
                        onClick={assignSubscriptions}>{t("Subscription.Membership.AssignSubscriptions.Title")}</Button>
                <Button variant="contained" disableElevation
                        color="primary" onClick={moveMember}>{t("Members.MoveMembers.Title")}</Button>
                <Button variant="contained" disableElevation
                        color="primary" onClick={() => setExportToCsv(true)}>{t("Members.ExportCsv")}</Button>
            </Grid>
            {
                exportToCsv &&
                <ExportMembers
                    organizationUnitId={organizationUnitId}
                    onError={() => setExportToCsv(false)}
                    onDone={() => setExportToCsv(false)}
                />
            }
            <Memberships
                headerTemplate={headerTemplate}
                rowTemplate={rowTemplate}
                refresh={refresh}
                {...props}/>
        </Grid>);
};
